import React, { useState, useRef, useEffect, useContext } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { isExpired, decodeToken } from "react-jwt";
import db from "../../../api/mongodb";
import "./Login.scss";
import logo from "../../../images/safe-logo-login.svg";
import Button from "react-bootstrap/Button";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import TextInput from "./TextInput";
import { UserContext } from "../../../api/UserProvider";

// the query string for you.
export function useQuery() {
    const { search } = useLocation();
    
    return React.useMemo(() => new URLSearchParams(search), [search]);
}
const schema = Yup.object({
    email: Yup.string().email("Invalid email address").required("Required"),
    password: Yup.string().required("Required"),
});

const Login = () => {
    const navigate = useNavigate();
    const [errorMsg, setErrorMsg] = useState("");
    const emailbox = useRef(null);
    const passwordbox = useRef(null);

    let query = useQuery();
    
    const userid = useContext(UserContext).id;
    
    useEffect(() => {
        // console.log()
        if (
            localStorage.getItem("token") &&
            isExpired(localStorage.getItem("token"))
            &&
            userid
        ) {
            setErrorMsg("Your session has expired! Please log in again.");
        }
    }, []);

    return (

        <Formik
            initialValues={{ email: "", password: "" }}
            validationSchema={schema}
            onSubmit={(values, { setSubmitting }) => {
                const user = {
                    email: values.email.toLowerCase(),
                    password: values.password,
                };

                setErrorMsg("");

                try {
                    db.post("/api/safeAPs/generateOTP", user)
                        .then((response) => {
                            // console.log(response)
                            // localStorage.setItem("token", response.data.token);
                            if (response.status === 200) {

                                //navigate to 2fapage
                                // TODO: ONCE 2FA is fixed, uncomment the following line
                                const redirectLink = query.get("redirectLink")
                                // const redirectLink = null;
                                if(redirectLink){
                                    navigate(`2faPage?redirectLink=${redirectLink}`, { state: { user: user } });

                                }else {
                                    navigate("/2faPage", { state: { user: user } });
                                    
                                }
                            } else {
                                setErrorMsg("Invalid username/password");
                            }
                        })
                        .catch((error) => {
                            setErrorMsg("Invalid username/password");
                        });
                } catch (err) { }

                setSubmitting(false);
            }}
        >
            <div className="login-background">
                <div className="login-card" style={{ paddingBottom: "100px" }}>
                    <Link to="/" className="safe-login-logo">
                        <img src={logo} alt="logo" width={200} style={{ paddingTop: "25px" }} />
                    </Link>


                    <Form className="login-form" autoComplete="on" noValidate>
                        <TextInput
                            label="Username"
                            name="email"
                            type="email"
                            autoComplete="email"
                            placeholder="Enter Email Address"
                            required
                        />

                        <TextInput
                            label="Password"
                            name="password"
                            type="password"
                            autoComplete="current-password"
                            placeholder="Enter Password"
                            required
                            errorMsg={errorMsg}
                        />
                        <Link to="/forgotPassword">
                            <p className="forgotPsw">Forgot Password?</p>
                        </Link>
                        <Button
                            className="login btn-primary"
                            variant="primary"
                            type="submit"
                        >
                            Log in
                        </Button>
                        <p className="newUser">
                            New user?{" "}
                            <span>
                                <Link to="/registration">
                                    <strong>Create an account</strong>
                                </Link>
                            </span>
                        </p>
                        <p className="terms" style={{ marginTop: "25px" }}>
                            By logging in, or creating an account, you are agreeing to our &nbsp;
                            <span>
                                <a target="_blank" href={`${process.env.REACT_APP_API_URL}/termsAndConditions`}>
                                    <strong>terms & conditions</strong>
                                </a>
                            </span>
                        </p>
                    </Form>
                </div>
                <p className="copyright-text">
                    © Copyright {new Date().getFullYear()} SAFE Design Technologies Inc.
                </p>
            </div>

        </Formik>




    );
};

export default Login;
